import type { FaireProductEntity } from "../../entity_types/product";

export const p_rgvu2z4hwm: FaireProductEntity = {
  token: "p_rgvu2z4hwm",
  type: "product",
  name: "In My Dark Romance Era Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/d0b660648ee97fa6201a5bc83ac27edaf09e7f41876417f284180ae1704f1d99.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/448212df21cdb58a13b020e2b47ee9c04d5037b5584218a28eeaa9a2e7fe95da.jpeg",
    "https://cdn.faire.com/fastly/435e239fc397daaddf9d436f0b8617e3608b8f85788bdfa8ecc4b1a0126d89c4.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/92f84d71dfb86b7e2c10aa34487bf7d0b41cf2063fc61b812b326c5a70c40399.jpeg",
    "https://cdn.faire.com/fastly/39304efee55385a6d87244067a27f605a45666cf2b622c9abf03def46603d9f2.jpeg",
    "https://cdn.faire.com/fastly/6868b2b08e5aed6d3e8615d4dc822505c0960192d330e6efb7d679af16630d05.jpeg",
    "https://cdn.faire.com/fastly/8fc8bf2542439acbe4f23c84fa80ac0529163f34d432df5bbd00d06e058ee170.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perfect for curling up with a steamy book about a moral gray area, and a heartbreak that will ruin your week in the best way possible.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:30.026Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
